const REDEMPTIONS_ROUTES = {
  path: 'redemptions',
  component: () => import('@/pages/Redemptions/RedemptionsPagesContainer.vue'),
  children: [
    {
      path: '',
      name: 'redemptions.index',
      component: () => import('@/pages/Redemptions/RedemptionsPage.vue'),
    },
    {
      path: ':id',
      name: 'redemptions.view',
      component: () => import('@/pages/Redemptions/RedemptionsViewPage.vue'),
    },
  ],
};

export default REDEMPTIONS_ROUTES;
